import { render, staticRenderFns } from "./MyTitle1.vue?vue&type=template&id=20ba2c67&scoped=true"
import script from "./MyTitle1.vue?vue&type=script&lang=js"
export * from "./MyTitle1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba2c67",
  null
  
)

export default component.exports